import MarkBillAsPaid from './MarkBillAsPaid';

export default MarkBillAsPaid;
